import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/comparison-view/comparison-view.component').then((m) => m.ComparisonViewComponent)
  },
  {
    path: 'reader',
    loadComponent: () =>
      import('./pages/comparison-view/comparison-view.component').then((m) => m.ComparisonViewComponent)
  },
  {
    path: 'search',
    loadComponent: () => import('./shared/bible-search/bible-search.component').then((m) => m.BibleSearchComponent)
  },
  // Unknown paths (e.g. old /import bookmarks — import is modal-only) land on the reader instead of a blank page.
  { path: '**', redirectTo: '' }
];
